export default __webpack_public_path__ + "static/media/kitchen3-afterF-768w.174c0dd7.avif";